/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import * as Types from '@r-client/data/graphql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type IHasWalletQueryVariables = Types.Exact<{ [key: string]: never }>;

export type IHasWalletQuery = { __typename?: 'Query'; hasWallet: boolean };

export type IWalletCreateMutationVariables = Types.Exact<{
  input: Types.IWalletCreateInput;
}>;

export type IWalletCreateMutation = {
  __typename?: 'Mutation';
  walletCreate: {
    __typename?: 'WalletCreatePayload';
    wallet?:
      | {
          __typename?: 'Wallet';
          id: string;
          wallabyWalletId: string;
          wallabyUserId: string;
          createdAt: string;
          deviceFingerprintsToClear: Array<string>;
          devices: Array<{
            __typename?: 'WalletDevice';
            id: string;
            fingerprint: string;
            name?: string | null | undefined;
            description?: string | null | undefined;
            isPasskey: boolean;
            isShareBased: boolean;
            state: Types.IDeviceState;
            parentId?: string | null | undefined;
            createdAt: string;
          }>;
        }
      | null
      | undefined;
    errors?:
      | Array<{
          __typename?: 'FieldError';
          field?: string | null | undefined;
          message: string;
          code?: string | null | undefined;
        }>
      | null
      | undefined;
  };
};

export type IWalletDeviceCreateMutationVariables = Types.Exact<{
  input: Types.IWalletDeviceCreateInput;
}>;

export type IWalletDeviceCreateMutation = {
  __typename?: 'Mutation';
  walletDeviceCreate: {
    __typename?: 'WalletDevicePayload';
    device?:
      | {
          __typename?: 'WalletDevice';
          id: string;
          fingerprint: string;
          name?: string | null | undefined;
          description?: string | null | undefined;
          isPasskey: boolean;
          isShareBased: boolean;
          state: Types.IDeviceState;
          parentId?: string | null | undefined;
          createdAt: string;
        }
      | null
      | undefined;
    errors?:
      | Array<{
          __typename?: 'FieldError';
          field?: string | null | undefined;
          message: string;
          code?: string | null | undefined;
        }>
      | null
      | undefined;
  };
};

export type IWalletDeviceDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type IWalletDeviceDeleteMutation = {
  __typename?: 'Mutation';
  walletDeviceDelete: {
    __typename?: 'WalletDeviceDeletePayload';
    success: boolean;
    errors?:
      | Array<{
          __typename?: 'FieldError';
          field?: string | null | undefined;
          message: string;
          code?: string | null | undefined;
        }>
      | null
      | undefined;
  };
};

export type IWalletDeviceUpdateMutationVariables = Types.Exact<{
  input: Types.IWalletDeviceUpdateInput;
}>;

export type IWalletDeviceUpdateMutation = {
  __typename?: 'Mutation';
  walletDeviceUpdate: {
    __typename?: 'WalletDevicePayload';
    device?:
      | {
          __typename?: 'WalletDevice';
          id: string;
          fingerprint: string;
          name?: string | null | undefined;
          description?: string | null | undefined;
          isPasskey: boolean;
          isShareBased: boolean;
          state: Types.IDeviceState;
          parentId?: string | null | undefined;
          createdAt: string;
        }
      | null
      | undefined;
    errors?:
      | Array<{
          __typename?: 'FieldError';
          field?: string | null | undefined;
          message: string;
          code?: string | null | undefined;
        }>
      | null
      | undefined;
  };
};

export type IWalletDevicesClearOthersMutationVariables = Types.Exact<{
  fingerprint: Types.Scalars['String']['input'];
}>;

export type IWalletDevicesClearOthersMutation = {
  __typename?: 'Mutation';
  walletDevicesClearOthers: {
    __typename?: 'WalletDevicesClearPayload';
    clearedCount: number;
    errors?:
      | Array<{
          __typename?: 'FieldError';
          field?: string | null | undefined;
          message: string;
          code?: string | null | undefined;
        }>
      | null
      | undefined;
  };
};

export type IWalletSessionCreateWithMfaMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type IWalletSessionCreateWithMfaMutation = {
  __typename?: 'Mutation';
  walletSessionCreateWithMfa: {
    __typename?: 'WalletSessionPayload';
    jwt?: string | null | undefined;
    expiresAt?: number | null | undefined;
    errors?:
      | Array<{
          __typename?: 'FieldError';
          field?: string | null | undefined;
          message: string;
          code?: string | null | undefined;
        }>
      | null
      | undefined;
  };
};

export type IWalletSessionCreateMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type IWalletSessionCreateMutation = {
  __typename?: 'Mutation';
  walletSessionCreate: {
    __typename?: 'WalletSessionPayload';
    jwt?: string | null | undefined;
    expiresAt?: number | null | undefined;
    errors?:
      | Array<{
          __typename?: 'FieldError';
          field?: string | null | undefined;
          message: string;
          code?: string | null | undefined;
        }>
      | null
      | undefined;
  };
};

export type IWalletQueryVariables = Types.Exact<{ [key: string]: never }>;

export type IWalletQuery = {
  __typename?: 'Query';
  wallet?:
    | {
        __typename?: 'Wallet';
        id: string;
        wallabyWalletId: string;
        wallabyUserId: string;
        createdAt: string;
        deviceFingerprintsToClear: Array<string>;
        devices: Array<{
          __typename?: 'WalletDevice';
          id: string;
          fingerprint: string;
          name?: string | null | undefined;
          description?: string | null | undefined;
          isPasskey: boolean;
          isShareBased: boolean;
          state: Types.IDeviceState;
          parentId?: string | null | undefined;
          createdAt: string;
        }>;
      }
    | null
    | undefined;
};

export const HasWalletDocument = gql`
  query HasWallet {
    hasWallet
  }
`;
export type HasWalletQueryResult = Apollo.QueryResult<
  IHasWalletQuery,
  IHasWalletQueryVariables
>;
export const WalletCreateDocument = gql`
  mutation WalletCreate($input: WalletCreateInput!) {
    walletCreate(input: $input) {
      wallet {
        id
        wallabyWalletId
        wallabyUserId
        createdAt
        devices {
          id
          fingerprint
          name
          description
          isPasskey
          isShareBased
          state
          parentId
          createdAt
        }
        deviceFingerprintsToClear
      }
      errors {
        field
        message
        code
      }
    }
  }
`;
export type IWalletCreateMutationFn = Apollo.MutationFunction<
  IWalletCreateMutation,
  IWalletCreateMutationVariables
>;
export type WalletCreateMutationResult =
  Apollo.MutationResult<IWalletCreateMutation>;
export type WalletCreateMutationOptions = Apollo.BaseMutationOptions<
  IWalletCreateMutation,
  IWalletCreateMutationVariables
>;
export const WalletDeviceCreateDocument = gql`
  mutation WalletDeviceCreate($input: WalletDeviceCreateInput!) {
    walletDeviceCreate(input: $input) {
      device {
        id
        fingerprint
        name
        description
        isPasskey
        isShareBased
        state
        parentId
        createdAt
      }
      errors {
        field
        message
        code
      }
    }
  }
`;
export type IWalletDeviceCreateMutationFn = Apollo.MutationFunction<
  IWalletDeviceCreateMutation,
  IWalletDeviceCreateMutationVariables
>;
export type WalletDeviceCreateMutationResult =
  Apollo.MutationResult<IWalletDeviceCreateMutation>;
export type WalletDeviceCreateMutationOptions = Apollo.BaseMutationOptions<
  IWalletDeviceCreateMutation,
  IWalletDeviceCreateMutationVariables
>;
export const WalletDeviceDeleteDocument = gql`
  mutation WalletDeviceDelete($id: ID!) {
    walletDeviceDelete(id: $id) {
      success
      errors {
        field
        message
        code
      }
    }
  }
`;
export type IWalletDeviceDeleteMutationFn = Apollo.MutationFunction<
  IWalletDeviceDeleteMutation,
  IWalletDeviceDeleteMutationVariables
>;
export type WalletDeviceDeleteMutationResult =
  Apollo.MutationResult<IWalletDeviceDeleteMutation>;
export type WalletDeviceDeleteMutationOptions = Apollo.BaseMutationOptions<
  IWalletDeviceDeleteMutation,
  IWalletDeviceDeleteMutationVariables
>;
export const WalletDeviceUpdateDocument = gql`
  mutation WalletDeviceUpdate($input: WalletDeviceUpdateInput!) {
    walletDeviceUpdate(input: $input) {
      device {
        id
        fingerprint
        name
        description
        isPasskey
        isShareBased
        state
        parentId
        createdAt
      }
      errors {
        field
        message
        code
      }
    }
  }
`;
export type IWalletDeviceUpdateMutationFn = Apollo.MutationFunction<
  IWalletDeviceUpdateMutation,
  IWalletDeviceUpdateMutationVariables
>;
export type WalletDeviceUpdateMutationResult =
  Apollo.MutationResult<IWalletDeviceUpdateMutation>;
export type WalletDeviceUpdateMutationOptions = Apollo.BaseMutationOptions<
  IWalletDeviceUpdateMutation,
  IWalletDeviceUpdateMutationVariables
>;
export const WalletDevicesClearOthersDocument = gql`
  mutation WalletDevicesClearOthers($fingerprint: String!) {
    walletDevicesClearOthers(fingerprint: $fingerprint) {
      clearedCount
      errors {
        field
        message
        code
      }
    }
  }
`;
export type IWalletDevicesClearOthersMutationFn = Apollo.MutationFunction<
  IWalletDevicesClearOthersMutation,
  IWalletDevicesClearOthersMutationVariables
>;
export type WalletDevicesClearOthersMutationResult =
  Apollo.MutationResult<IWalletDevicesClearOthersMutation>;
export type WalletDevicesClearOthersMutationOptions =
  Apollo.BaseMutationOptions<
    IWalletDevicesClearOthersMutation,
    IWalletDevicesClearOthersMutationVariables
  >;
export const WalletSessionCreateWithMfaDocument = gql`
  mutation WalletSessionCreateWithMfa {
    walletSessionCreateWithMfa {
      jwt
      expiresAt
      errors {
        field
        message
        code
      }
    }
  }
`;
export type IWalletSessionCreateWithMfaMutationFn = Apollo.MutationFunction<
  IWalletSessionCreateWithMfaMutation,
  IWalletSessionCreateWithMfaMutationVariables
>;
export type WalletSessionCreateWithMfaMutationResult =
  Apollo.MutationResult<IWalletSessionCreateWithMfaMutation>;
export type WalletSessionCreateWithMfaMutationOptions =
  Apollo.BaseMutationOptions<
    IWalletSessionCreateWithMfaMutation,
    IWalletSessionCreateWithMfaMutationVariables
  >;
export const WalletSessionCreateDocument = gql`
  mutation WalletSessionCreate {
    walletSessionCreate {
      jwt
      expiresAt
      errors {
        field
        message
        code
      }
    }
  }
`;
export type IWalletSessionCreateMutationFn = Apollo.MutationFunction<
  IWalletSessionCreateMutation,
  IWalletSessionCreateMutationVariables
>;
export type WalletSessionCreateMutationResult =
  Apollo.MutationResult<IWalletSessionCreateMutation>;
export type WalletSessionCreateMutationOptions = Apollo.BaseMutationOptions<
  IWalletSessionCreateMutation,
  IWalletSessionCreateMutationVariables
>;
export const WalletDocument = gql`
  query Wallet {
    wallet {
      id
      wallabyWalletId
      wallabyUserId
      createdAt
      deviceFingerprintsToClear
      devices {
        id
        fingerprint
        name
        description
        isPasskey
        isShareBased
        state
        parentId
        createdAt
      }
    }
  }
`;
export type WalletQueryResult = Apollo.QueryResult<
  IWalletQuery,
  IWalletQueryVariables
>;
